import FileUploader from './FileUploader';
//import IndividualGiving_Instructions_noBackground from './assets/IndividualGiving_Instructions_noBackground.png';
//import OpenPledges_DataDefinitions from './assets/OpenPledges_Instructions_DataFormat_20250113.svg'
import OpenPledges_Instructions from './assets/pledges_instructions.svg'
import IndividualGiving_Instructions from './assets/gifts_instructions.svg'
// import logo from src/assets/IndividualGivingLogo.png

function Pledges({ user, styles }) {
  return (
    <>
      <div className="file-uploader">
        <FileUploader useremail={user.attributes.email} uploadOption='pledges' />
      </div>
      {/* Upload Instructions */}
      <div style={styles.instructionsContainer}>
        <img src={IndividualGiving_Instructions} alt="Data Definitions Example" style={styles.image} />
      </div>
      <div style={styles.instructionsContainer}>
        <img src={OpenPledges_Instructions} alt="Data Definitions Example" style={styles.image} />
        {/*
        <h2>Upload Instructions</h2>
        <p style={styles.instructionText}>
          The data you are uploading should be in the format demonstrated below and submitted as a&nbsp; 
          <strong>.csv</strong> file. Please remove any extra columns that are not listed below. Add 
          additional installments as new columns on the right of the document and notate with an underscore 
          followed by the number of the installment. Each installment should contain:
        </p>
        <ul>
          <li>Installment Import ID</li>
          <li>Installment Date</li>
          <li>Installment Amount</li>
          <li>Installment Balance</li>
        </ul>
        <h3>Data Format:</h3>
        <img src={OpenPledges_DataDefinitions} alt="Data Format Example" style={styles.image} />

        <h3>Data Definitions:</h3>
        <img src={OpenPledges_Instructions} alt="Data Definitions Example" style={styles.image} />
        */}
        
      </div>
    </>
  );
}

export default Pledges;